import React, { useState, useMemo } from "react";
import "./LocationWiseProducts.css";

const LocationWiseProducts = ({ locationProducts }) => {
  const [openLocation, setOpenLocation] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  const toggleLocation = (location) => {
    setOpenLocation(openLocation === location ? null : location);
  };

  // Filter locations based on search term (case-insensitive)
  const filteredLocations = useMemo(() => {
    return Object.entries(locationProducts).filter(([location]) => location.toLowerCase().includes(searchTerm.toLowerCase()));
  }, [searchTerm, locationProducts]);

  return (
    <div className="sidebar">
      <h2 className="sidebar-title">Warehouse Locations</h2>

      <input type="text" placeholder="Search locations..." className="location-search" value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />

      {filteredLocations.length === 0 ? (
        <p className="empty-text">No locations available.</p>
      ) : (
        filteredLocations.map(([location, products]) => {
          const totalQuantity = products.reduce((sum, product) => sum + (product.quantity || 0), 0);

          return (
            <div key={location} className="accordion-item">
              <button className="accordion-header" onClick={() => toggleLocation(location)}>
                <span className="accordion-title">
                  📦 {location} ({totalQuantity})
                </span>
                {products.length > 0 && <span className={`accordion-arrow ${openLocation === location ? "open" : ""}`}>▼</span>}
              </button>

              {openLocation === location && (
                <div className="accordion-content">
                  {products.length > 0 ? (
                    <div className="chips-container">
                      {products.map((product, index) => (
                        <span key={index} className="chip">
                          {product.product_name} ({product.quantity})
                        </span>
                      ))}
                    </div>
                  ) : (
                    <p className="no-products">No products here.</p>
                  )}
                </div>
              )}
            </div>
          );
        })
      )}
    </div>
  );
};

export default LocationWiseProducts;
